export const phaseColors = ["#ff0000", "#00ee00", "#3f3fff", "#af00ff"];

